import { base44 } from '@/api/base44Client';
import { afterHuman, isHuman } from '@/lib/humanGate';
import { isBot } from '@/lib/isBot';

// Collects the topic names shown on screen and asks for them in small batches.
// Before the visitor interacts, only already-saved translations are fetched.
const asked = new Set();
const pending = new Map(); // lang -> Set(name)
let timer = null;

function flush(onResult) {
  timer = null;
  pending.forEach((set, lang) => {
    const names = [...set].slice(0, 20);
    names.forEach(n => set.delete(n));
    if (set.size === 0) pending.delete(lang);
    if (names.length === 0) return;
    const cachedOnly = !isHuman();
    base44.functions.invoke('translateTopicNames', { language: lang, names, cached_only: cachedOnly })
      .then(res => {
        const items = res.data?.items || {};
        onResult(lang, items);
        const left = names.filter(n => !items[n]);
        if (cachedOnly && left.length) afterHuman(() => {
          left.forEach(n => asked.delete(`${lang}:${n}`));
          requestTopic(lang, left, onResult);
        });
      })
      .catch(() => {});
  });
  if (pending.size > 0) timer = setTimeout(() => flush(onResult), 300);
}

export function requestTopic(lang, names, onResult) {
  if (isBot || !lang || lang === 'en') return;
  names.forEach(name => {
    const key = `${lang}:${name}`;
    if (asked.has(key)) return;
    asked.add(key);
    if (!pending.has(lang)) pending.set(lang, new Set());
    pending.get(lang).add(name);
  });
  if (!timer && pending.size > 0) timer = setTimeout(() => flush(onResult), 300);
}